import React, { useCallback, useEffect, useState } from 'react';

import {
  Button,
  Icon,
  Loading,
  Typography,
  version as componentsVersion
} from 'wtb-components';
import { version as utilsVersion } from 'wtb-utils';
import { getVersions } from 'api';
import uiIcons from 'uiIcons';
import styles from './Versions.module.css';

const Versions = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ coreVersion, setCoreVersion ] = useState();
  const [ requestError, setRequestError ] = useState();

  const refresh = useCallback(() => {
    setIsLoading(true);
    setRequestError(null);

    getVersions()
      .then((response) => {
        setCoreVersion(response.buildVersion);
      })
      .catch((error) => {
        setRequestError(error.toString());
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  useEffect(refresh, [ refresh ]);

  return (
    <div className={styles.root}>
      <div className={styles.main}>
        <div className={styles.block}>
          <Typography variant="h6">FRONTEND</Typography>

          <div>
            <Typography component="div" variant="subtitle1" fontWeight="bold">Checkout</Typography>
            <Typography>{process.env.REACT_APP_VERSION}</Typography>
          </div>

          <div>
            <Typography component="div" variant="subtitle1" fontWeight="bold">Component library</Typography>
            <Typography>{componentsVersion || 'Version not found'}</Typography>
          </div>

          <div>
            <Typography component="div" variant="subtitle1" fontWeight="bold">Utils library</Typography>
            <Typography>{utilsVersion || 'Version not found'}</Typography>
          </div>
        </div>

        <div className={styles.block}>
          <Typography variant="h6">BACKEND</Typography>

          {isLoading && (
            <div className={styles.centered}>
              <Loading />
            </div>
          )}
          {!isLoading && (
            requestError
              ? (
                <div>
                  <h4 className={styles.errorMessage}>{requestError}</h4>
                  <div className={styles.centered}>
                    <Button color="secondary" icon={<Icon name={uiIcons.refresh} />} onClick={refresh}>Refresh</Button>
                  </div>
                </div>
              ) : (
                <>
                  <div>
                    <Typography component="div" fontWeight="bold">Core</Typography>
                    <Typography>{coreVersion}</Typography>
                  </div>
                </>
              )
          )}
        </div>
      </div>
    </div>
  );
};

export default Versions;
